<style src="./ListView.scss" lang="scss"></style>

<template lang="pug">
  .list-view(
    :class='classList'
  )
    .list-view__progress(
      v-if='progress'
      :style='`transform: scaleX(${Math.floor(progress) / 100})`'
    )

    .list-view__cover(
      v-if='!hideCover'
    )
      .list-view__crop
        img.list-view__image(
          v-if='cover'
          :src='`${HOST_URL}${cover}`'
          alt
        )
      .list-view__controls(
        v-if='showControls'
      )
        .list-view__play-button(
          @click='$emit("play")'
          v-if='!running'
        )
          ControlButton(
            type='play'
            icon='play'
            size='small'
          )
        .list-view__play-button(
          @click='$emit("pause")'
          v-else
        )
          ControlButton(
            type='pause'
            icon='pause'
            size='small'
          )
    .list-view__body
      .list-view__headline
        router-link.list-view__name(
          v-if='link && active'
          :title='title'
          :to='link'
        ) {{ title }}

        span.list-view__name(
          v-if='link && !active'
        ) {{ title }}

        .list-view__name(
          @click='editTitle'
          v-else-if='!link && !onEdit'
        ) {{ title }}

        input.list-view__name(
          @blur='saveTitle'
          @keyup.enter.stop='saveTitle'
          :value='title'
          v-else-if='!link && onEdit'
          v-shortkey.avoid='true'
          ref='title'
        )

        .list-view__artists(
          v-if='artists.length'
        )
          router-link.list-view__artist(
            v-if='active'
            v-for='artist in artists'
            :key='artist.id'
            :to='`/artists/${artist.id}`'
          ) {{ artist.name }}
          span.list-view__artist(
            v-else
            v-for='artist in artists'
            :key='artist.id'
          ) {{ artist.name }}
    .list-view__footer
      .list-view__duration(
        v-if='duration'
      ) {{ duration | duration }}

      button.list-view__delete(
        v-if='removable && !checked'
        @click='$emit("delete")'
        type='button'
        :title='$l10n("REMOVE")'
      )
        Icon(
          name='delete'
        )

      button.list-view__restore(
        v-if='removable && checked'
        @click='$emit("restore")'
        :title='$l10n("RESTORE")'
        type='button'
      )
        Icon(
          name='restore'
        )

      .list-view__likes(
        v-if='likes && !removable'
      )
        Like(
          v-if='active'
          color='accent'
          size='big'
          :liked='likes.liked'
          :count='likes.count'
          @like='$emit("like")'
          @unlike='$emit("unlike")'
        )

      .list-view__context-menu(
        v-if='!removable'
      )
        ContextMenu(
          v-if='active'
          :list='contextMenu'
          color='grey'
        )
</template>

<script>
import Icon from "@/components/Icon/Icon";
import Cover from "@/components/Cover/Cover";
import Button from "@/components/Button/Button";
import ControlButton from "@/components/ControlButton/ControlButton";
import Like from "@/components/Like/Like";
import ContextMenu from "@/components/ContextMenu/ContextMenu";

import { HOST_URL } from "@/constants";

export default {
  inheritAttrs: false,
  name: "ListView",
  props: {
    type: {
      type: String,
      validator(value) {
        return ["track"].includes(value);
      }
    },
    progress: [String, Number],
    cover: String,
    hideCover: {
      type: Boolean,
      default: false
    },
    showControls: Boolean,
    editableTitle: Boolean,
    running: Boolean,
    link: String,
    title: String,
    artists: {
      type: Array,
      default: () => []
    },
    duration: [Number, String],
    removable: Boolean,
    checked: Boolean,
    active: {
      type: Boolean,
      default: true
    },
    disabled: Boolean,
    likes: Object,
    contextMenu: Array
  },
  data: () => ({
    HOST_URL,
    onEdit: false
  }),
  components: {
    Icon,
    Cover,
    Button,
    ControlButton,
    Like,
    ContextMenu
  },
  computed: {
    classList() {
      return {
        "is-removable": this.removable,
        "is-removed": this.checked,
        "is-disabled": this.disabled,
        "is-running": this.running,
        "on-edit": this.editableTitle && this.onEdit,
        "has-editable-title": this.editableTitle,
        "has-controls": this.showControls
      };
    }
  },
  methods: {
    saveTitle() {
      if (this.editableTitle && this.onEdit) {
        this.onEdit = false;

        const newTitle = this.$refs.title.value;

        if (newTitle !== this.title) {
          this.$emit("rename", newTitle);
        }
      }
    },
    editTitle() {
      if (this.editableTitle) {
        this.onEdit = true;
        this.$nextTick(() => {
          this.$refs.title.focus();
        });
      }
    }
  }
};
</script>
